import { firstValueFrom } from 'rxjs';
import { ReportingTransactionsBack } from '../interfaces/types';
import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { IReportingHttpService } from '../interfaces';
import { ERROR_ACTION_KEY } from '../../../tokens';

@Injectable()
export class ReportingHttpService implements IReportingHttpService {
  constructor(protected httpClient: HttpClient) {}

  getReportingPartners(country: string, startDate: string, endDate: string, codeCinema = 'HO'): Promise<ReportingTransactionsBack> {
    return firstValueFrom(
      this.httpClient.get<ReportingTransactionsBack>(`/reporting/partners/${codeCinema}`, {
        params: { country, startDate, endDate },
        context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.partner_report'),
      }),
    );
  }

  getReportingTransactions(country: string, startDate: string, endDate: string, theaterCode?: string): Promise<ReportingTransactionsBack> {
    const theater = theaterCode ? `/${theaterCode}` : '';
    return firstValueFrom(
      this.httpClient.get<ReportingTransactionsBack>(`/reporting/advanced${theater}`, {
        params: { country, startDate, endDate },
        context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.transaction_report'),
      }),
    );
  }
}
